"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageHeaderDropdown = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../../context");

var _RotatingContainer = _interopRequireDefault(require("../../helpers/RotatingContainer"));

var _hooks = require("../../hooks");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _popover = require("../../popover");

var _constants = require("../../popover/constants");

var _utils = require("../../utils");

var _ = require("./");

var _core = require("@emotion/core");

var _excluded = ["children", "items"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Ul = ( /*#__PURE__*/0, _styledBase.default)('ul', {
  target: "en5j4y30"
})(process.env.NODE_ENV === "production" ? {
  name: "1x0at3m",
  styles: "padding:0;margin:0;overflow-y:auto;overflow-x:hidden;"
} : {
  name: "1x0at3m",
  styles: "padding:0;margin:0;overflow-y:auto;overflow-x:hidden;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Li = (0, _context.styledWithTheme)('li')(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    listStyleType: 'none',
    margin: (0, _utils.px)(selectors.space('S200'))
  };
});

var PageHeaderDropdownWithoutDocs = function PageHeaderDropdownWithoutDocs(_ref2) {
  var children = _ref2.children,
      items = _ref2.items,
      buttonProps = (0, _objectWithoutProperties2.default)(_ref2, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var pageHeaderButtonRef = (0, _react.useRef)(null);

  var _useResizeObserver = (0, _hooks.useResizeObserver)(),
      dropdownWrapperRef = _useResizeObserver.ref,
      dropdownHeight = _useResizeObserver.height;

  var handleToggle = function handleToggle() {
    setIsOpen(!isOpen);
  };

  var handleClose = function handleClose() {
    setIsOpen(false);
  };

  return (0, _core.jsx)(_layout.Row, {
    alignItems: "stretch",
    height: "100%",
    ref: dropdownWrapperRef
  }, (0, _core.jsx)(_.PageHeaderButton, (0, _extends2.default)({
    "aria-expanded": isOpen,
    onClick: handleToggle,
    isSelected: isOpen
  }, buttonProps, {
    ref: pageHeaderButtonRef
  }), (0, _core.jsx)(_layout.Row, {
    gridGap: 4,
    alignItems: "center"
  }, children, (0, _core.jsx)(_RotatingContainer.default, {
    isRotated: isOpen
  }, (0, _core.jsx)(_icons.IconChevronDown, {
    "aria-hidden": true
  })))), (0, _core.jsx)(_popover.PopoverController, {
    target: pageHeaderButtonRef,
    isOpen: isOpen,
    close: handleClose,
    position: _popover.PopoverPosition.BottomTrailing
  }, (0, _core.jsx)(Ul, {
    role: "list",
    style: {
      maxHeight: "calc(100vh - ".concat(dropdownHeight + _constants.ARROW_HEIGHT * 2, "px)")
    }
  }, items.map(function (item, index) {
    return (0, _core.jsx)(Li, {
      onClick: handleClose,
      key: index
    }, item);
  }))));
};

var PageHeaderDropdownWithDocs = (0, _stencilReactDesc.describe)(PageHeaderDropdownWithoutDocs).description('Dropdown for PageHeader.');
PageHeaderDropdownWithDocs.propTypes = _objectSpread(_objectSpread({}, _.PageHeaderButton.describedPropTypes), {}, {
  items: _stencilReactDesc.PropTypes.arrayOf(_stencilReactDesc.PropTypes.node).description('List of PageHeaderDropdownButton or PageHeaderDropdownLink to be rendered in the dropdown.').isRequired
});
var PageHeaderDropdown = (0, _utils.withTestAttributes)({})(PageHeaderDropdownWithDocs);
exports.PageHeaderDropdown = PageHeaderDropdown;
PageHeaderDropdown.displayName = 'PageHeaderDropdown';